
import { DateUtils } from 'react-frontend-utils'
import store from 'store'
import { Member } from './Member'




export const BarcodeSuggestionType = {  
    NEXT_NUMERIC: 'Next Numeric',
    RANDOM_NUMERIC: 'Random Numeric',
    RANDOM_ALPHANUMERIC: 'Random Alphanumeric',

    fromSetting: (type) => {
        if (!type || type === 'None')
            return BarcodeSuggestionType.NEXT_NUMERIC;

        return type.replace(/_/g, ' ');
    },
    
    isOneOf: (type) => {
        switch (type) {
            case BarcodeSuggestionType.NEXT_NUMERIC:
            case BarcodeSuggestionType.RANDOM_NUMERIC:
            case BarcodeSuggestionType.RANDOM_ALPHANUMERIC:
                return true;
            default:
                return false;
        }
    }
 
};

Object.freeze(BarcodeSuggestionType);


export const RecentCheckInWarnMode = {  
    NONE: 'Never',
    THIS_LOCATION: 'This Location',
    ANY_LOCATION: 'Any Location',
    
    isOneOf: (type) => {
        switch (type) {
            case RecentCheckInWarnMode.NONE:
            case RecentCheckInWarnMode.THIS_LOCATION:
            case RecentCheckInWarnMode.ANY_LOCATION:
                return true;
            default:
                return false;
        }
    }
 
};

Object.freeze(BarcodeSuggestionType);


const defaultLocation = "Default Location";  //default location if not set


//Forward declaration, to use it within PP twice
function getLocation() {
    const location = store.get("location");

    if (!location) {
        return defaultLocation;  //default location if not set
    }   
    else {
        return location;
    }
};


/**
 * Holds the global variables for the frontend
 */
export const PP = {
    
    user: null,                                     //object of type User, the currently logged in user or null if none
    selectedDatabase: null,                         //String identifying the currently selected database, or null if none
    currency: "???",                                //String identifying the currency, ISO currency value
    printCapabilities: [],                          //Array of Kinds, indentifying the printing capabilities: EPASS, CARD, PDF
    isSelfPrintClient: false,                       //true if this is a self-print client
    checkInDisabled: false,                         //can be set to true after loading Home
    attendedMarketplacePurchaseEnabled: false,      //can be set to true after loadingHome
    checkInPreferencesDidSync: false,
    newMembershipPreferencesDidSync: false,

    isLocationSet: () => {return getLocation() !== defaultLocation},           //returns true if the location is set, false if not

    getLocation: () => {return getLocation();},
          
    setLocation: (location) => {
        store.set("location", location);    
    },
    
    viewingStatsLocation: getLocation(),   //default to our current location, then leave set for the session
    viewingStatsAggregate: null,           //will be set to initial value on stats load

    getLastDatabase: () => {
        return store.get("database");
    },
    
    setLastDatabase: (database) => {
        store.set("database", database);    
    },
    
    getDateFormat: () => {
        const fmt = store.get("dateFormat");
        if (!fmt)
            return DateUtils.DateFormatType.ISO8601;
        else
            return fmt;    
    },
    
    setDateFormat: (format) => {
        if (!DateUtils.DateFormatType.isOneOf(format)) {
            console.log("Invalid DateFormatType: " + format);
            return;
        }
        store.set("dateFormat", format);    
    },
    
    soundEffectsEnabled: () => {
        const disabled = store.get("soundEffectsDisabled");  //use disabled for "falsy" values to be true
        if (!disabled)
            return true;
        
        return disabled === 'true' ? false : true;
    },
    
    enableSoundEffects: (enable) => {
        store.set("soundEffectsDisabled", enable ? 'false' : 'true');           
    },
    
    checkOutEnabled: () => {
        const enabled = store.get("checkOutEnabled");
        if (!enabled)
            return false;
        
        return enabled === 'true' ? true : false;
    },
    
    enableCheckOut: (enable) => {
        store.set("checkOutEnabled", enable ? 'true' : 'false');           
    },
    
    guestRegisterEnabled: () => {
        const enabled = store.get("guestRegister");
        if (!enabled)
            return false;
        
        return enabled === 'true' ? true : false;
    },
    
    enableGuestRegister: (enable) => {
        store.set("guestRegister", enable ? 'true' : 'false');           
    },

    checkInNoteEnabled: () => {
        const enabled = store.get("checkInNote");
        if (!enabled)
            return false;
        
        return enabled === 'true' ? true : false;
    },
    
    enableCheckInNote: (enable) => {
        store.set("checkInNote", enable ? 'true' : 'false');           
    },
    
    multiMemberCheckinEnabled: () => {
        const enabled = store.get("multiMemberCheckin");
        if (!enabled)
            return false;
        
        return enabled === 'true' ? true : false;
    },
    
    enableMultiMemberCheckin: (enable) => {
        store.set("multiMemberCheckin", enable ? 'true' : 'false');           
    },
    
    
    virtualGuestPassHidden: () => {
        const hidden = store.get("virtualGuestPassHidden");
        if (!hidden)
            return false;
        
        return hidden === 'true' ? true : false;
    },

    allowDropIns: () => {
        const allowed = store.get("allowDropIns");
        if (!allowed)
            return false;
        
        return allowed === 'true' ? true : false;
    },
    
    setAllowDropIns: (enable) => {
        store.set("allowDropIns", enable ? 'true' : 'false');           
    },
    
    setVirtualGuestPassHidden: (enable) => {
        store.set("virtualGuestPassHidden", enable ? 'true' : 'false');           
    },
    
    addressAndAgeHidden: () => {
        const hidden = store.get("addressAndAgeHidden");
        if (!hidden)
            return false;
        
        return hidden === 'true' ? true : false;
    },
    
    
    setAddressAndAgeHidden: (enable) => {
        store.set("addressAndAgeHidden", enable ? 'true' : 'false');           
    },
    
    
    notesHidden: () => {
        const hidden = store.get("notesHidden");
        if (!hidden)
            return false;
        
        return hidden === 'true' ? true : false;
    },
    
    
    setNotesHidden: (enable) => {
        store.set("notesHidden", enable ? 'true' : 'false');           
    },

    customFieldNames: () => {
        const names = store.get("customFieldNames");
        if (!names || names.length !== 5)
            return ["Custom 1", "Custom 2", "Custom 3", "Custom 4", "Custom 5"];
        return names;
    },

    setCustomFieldNames: (names) => {
        if (!Array.isArray(names)) {
            console.log("Invalid custom field names array: " + names);
            return;
        }
        store.set("customFieldNames", names);
    },

    memberActionNames: () => {
        const names = store.get("memberActionNames");
        if (!names || names.length !== Member.defaultActionNames.length)
            return [...Member.defaultActionNames];
        return names;
    },

    setMemberActionNames: (names) => {
        if (!Array.isArray(names) || names.length !== Member.defaultActionNames.length) {
            console.log("Invalid member action names array: " + names);
            return;
        }
        store.set("memberActionNames", names);
    },

    getMemberActionName: (index) => {
        const names = PP.memberActionNames();
        if (index < 0 || index >= names.length)
            return "";
        return names[index];
    },

    getCustomLabel: (index) => {
        const names = PP.customFieldNames();
        if (index < 0 || index >= names.length)
            return "Custom " + index;
        return names[index];
    },
   
    
    barcodeSuggestionType: () => {
        const type = store.get("barcodeSuggestionType");
        if (!type)
            return BarcodeSuggestionType.NEXT_NUMERIC;
        else
            return type;  
    },
    
    setBarcodeSuggestionType: (type) => {
        if (!BarcodeSuggestionType.isOneOf(type)) {
            console.log("Invalid BarcodeSuggestionType: " + type);
            return;
        }
        store.set("barcodeSuggestionType", type); 
    },
    
    barcodeSuggestionDigits: () => {
        const digits = store.get("barcodeSuggestionDigits");
        if (!digits)
            return 5;
        else
            return digits;  
    },
    
    setBarcodeSuggestionDigits: (digits) => {
        if (digits < 1)
            return null;
        store.set("barcodeSuggestionDigits", digits); 
    },
    
    //Get time as date string, or null for never.  Default = never    
    initialExpirationDate: () => {
        const date = store.get("initialExpirationDate");
        if (!date)
            return null;  //Never
        else
            return date;  
    },
    
    //Set time as date string, or null for never
    setInitialExpirationDate: (date) => {
        store.set("initialExpirationDate", date); 
    },
    
    
    initialGuestPasses: () => {
        const val = store.get("initialGuestPasses");
        if (!val)
            return 0;
        else
            return val;  
    },
    
    setInitialGuestPasses: (val) => {
        store.set("initialGuestPasses", val); 
    },
    
    initialEntryPasses: () => {
        const val = store.get("initialEntryPasses");
        if (val == null)
            return -1;  //unlimited
        else
            return val;  
    },
    
    setInitialEntryPasses: (val) => {
        store.set("initialEntryPasses", val); 
    },
    
    dateFormat: (date) => {
        return DateUtils.dateFormat(date, PP.getDateFormat());
    },
    
    checkInTimeFormat: (date) => {
        return DateUtils.timeFormat(date, PP.getDateFormat());
    },
    
    billingTimeFormat: (date) => {
        return new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(date)
    },
    
    
    parseDate: (dateString) => {
        return DateUtils.parseDate(dateString, PP.getDateFormat());
    },
    
    exampleDateString: () => {
        return DateUtils.exampleDateString(PP.getDateFormat());        
    },
        
    recentCheckInWarnMode: () => {
        const mode = store.get("recentCheckInWarnMode");
        if (!mode)
            return RecentCheckInWarnMode.ANY_LOCATION;
        else
            return mode;  
    },
    
    setRecentCheckInWarnMode: (mode) => {
        if (!RecentCheckInWarnMode.isOneOf(mode)) {
            console.log("Invalid RecentCheckInWarnMode: " + mode);
            return;
        }
        store.set("recentCheckInWarnMode", mode); 
    },
    
    recentCheckInWarnTime: () => {  //hours
        const val = store.get("recentCheckInWarnTime");
        if (!val)
            return 1;  //1 hour default
        else
            return val;  
    },
    
    setRecentCheckInWarnTime: (val) => {
        store.set("recentCheckInWarnTime", val); 
    }
    
    
};

Member.setActionNames(PP.memberActionNames());
